import { render, staticRenderFns } from "./BeschrijvingPand.vue?vue&type=template&id=3801da10"
import script from "./BeschrijvingPand.vue?vue&type=script&lang=js"
export * from "./BeschrijvingPand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports